import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormSelectComponent from 'webapp/components/form/select';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class UserPopupSelectComponent extends PopupInnerModalComponent<PopupData.User.Select> {
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;

	@tracked selected: string | null = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.selected = this.currentUserId;
	}

	get title() {
		return this.popupData.title;
	}

	get text() {
		return this.popupData.text;
	}

	get currentUserId() {
		return this.popupData.currentUserId;
	}

	get userOptions(): LabelValuePairString[] {
		return (
			this.popupData.userOptions ??
			this.mmUsersService.activatedAndVerifiedUsersWithoutViewersList
		);
	}

	@action
	select(userId: string): void {
		this.selected = userId;
	}

	@action
	save(): void {
		this.popupData.onSelect(this.selected);
		this.close();
	}
	<template>
		<div>
			<div class="title">
				<CommonUiIconComponent @name="User" @size="lg" />
				{{this.title}}
			</div>
			<div class="content">
				{{#if this.text}}
					<p>{{this.text}}</p>
				{{/if}}
				<FormSelectComponent
					name="owner"
					@selected={{this.selected}}
					@options={{this.userOptions}}
					@onChange={{this.select}}
					@isNumeric={{false}}
					@isRequired={{true}}
					@showFloatlabel={{false}}
				/>
				<div class="controls2">
					<div class="controls2__right">
						<SubmitButtonComponent
							@text="Cancel"
							@theme="grey-empty"
							@noDelay={{true}}
							@onTrigger={{this.close}}
						/>
						<SubmitButtonComponent
							@text="Save"
							@extraClass="save"
							@onTrigger={{this.save}}
						/>
					</div>
				</div>
			</div>
		</div>
	</template>
}
